export default __webpack_public_path__ + "static/media/image-007.a4c6bb5a.jpg";